import api from "./api";

// "Minhas Transportadoras" (carteira do embarcador) — PO1-2620, H1.
// Endpoint no backend_hub (módulo transportadoras).

export async function listMinhasTransportadoras({ embarcadorId, search, status, page, pageSize } = {}) {
  const { data } = await api.get("/transportadoras/minhas", {
    params: { embarcadorId, search: search || undefined, status: status ?? undefined, page, pageSize },
  });
  return data;
}

// Remove o vínculo com a carteira (soft-delete, ver TransportadoraRepository.unlinkEmbarcador).
// Não apaga o cadastro da transportadora — pode ser readicionada depois pelo Catálogo.
export async function removerMinhaTransportadora({ embarcadorId, transportadoraId }) {
  const { data } = await api.delete(`/transportadoras/minhas/${transportadoraId}`, { params: { embarcadorId } });
  return data;
}

// PO1-3166: conecta o vínculo à esteira sem passar pelo convite. Para a
// transportadora que JÁ acessa o portal: ela não precisa de convite, mas o
// vínculo precisa de habilitação. Idempotente no backend. Desde a PO1-3283 a
// carteira usa "Adicionar transportadora"; a rota fica para compatibilidade.
export async function conectarMinhaTransportadora({ embarcadorId, transportadoraId }) {
  const { data } = await api.post(`/transportadoras/minhas/${transportadoraId}/conectar`, null, {
    params: { embarcadorId },
  });
  return data;
}

// PO1-3283: "Adicionar transportadora" pela carteira. Substitui Convidar e
// Conectar. body { embarcadorId, cnpj, apelido?, contatos: { ti, logistica?, cotacao? } }
// com TI (nome + e-mail) obrigatório. Devolve a resposta inteira do axios porque
// o STATUS diz a fase: 201 pedido à Everlog (fase 1), 200 onboarding iniciado
// (fase 2), 202 curadoria. Erros 422/400 vêm com { error, code }.
export async function adicionarMinhaTransportadora({ embarcadorId, cnpj, apelido, contatos }) {
  const res = await api.post("/transportadoras/minhas", { embarcadorId, cnpj, apelido: apelido || undefined, contatos });
  return { status: res.status, data: res.data };
}

// PO1-3281: "corrigi, enviar de novo" por quem deu a entrada — só o par deste embarcador.
export async function reenviarHomologacaoMinhaTransportadora({ embarcadorId, transportadoraId }) {
  const { data } = await api.post(`/transportadoras/minhas/${transportadoraId}/reenviar-homologacao`, { embarcadorId });
  return data;
}
